import styled from "styled-components";

export const UiModalTitle = styled.div`
	display: flex;
	align-items: center;
	column-gap: 6px;
	color: #1890ff;

	i {
		width: 20px;
	}
`;

export const StyledQuestionPreview = styled.div`
	.infoList {
		overflow-y: auto;
		max-height: 50vh;
	}

	.infoRow {
		display: flex;
		margin-bottom: 14px;
	}

	.infoLabel {
		width: 100px;
		flex-shrink: 0;
		color: #333;
	}

	.infoValue {
		display: flex;
		flex-wrap: wrap;
		column-gap: 16px;
		row-gap: 4px;
		color: #333;
		word-break: break-all;
	}

	.loading,
	.empty {
		display: flex;
		align-items: center;
		justify-content: center;
		min-height: 120px;
		color: #8b90a0;
	}
`;
